import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";

import React from "react";
import { connect } from "react-redux";

import { pwa_modal } from "../redux/Login/LoginActionCreators";
import Store from "../redux/Store";
import { useStyles } from "../styles/mainStyles";

const PwaPromp = ({ pwa_install }) => {
  const handleCloseDialog = () => {
    Store.dispatch(pwa_modal({ mode: false, event: {} }));
  };
  const style = useStyles();
  return (
    <>
      <Zoom
        in={!localStorage.pwa && pwa_install.mode}
        unmountOnExit
        timeout={500}
      >
        <Tooltip
          title="افزودن به صفحه اصلی"
          classes={{ tooltip: style.Tooltip }}
          placement="right-end"
        >
          <IconButton
            onClick={async () => {
              pwa_install.event.prompt();

              await pwa_install.event.userChoice.then(() => {});
              handleCloseDialog();
            }}
          >
            <GetApp style={{ color: "white" }} />
          </IconButton>
        </Tooltip>
      </Zoom>
    </>
  );
};

const mapStateToProps = (props) => {
  let { loginReducer } = props;
  let { pwa_install } = loginReducer;

  return { pwa_install };
};

export default connect(mapStateToProps)(PwaPromp);
